export const environment = {
  configUrl: './config-release/config.release.json'
};
